export default __webpack_public_path__ + "media/images/placeholder/2x3-38d708abc7e0c72eb9fe1d2cef8cef16.jpg";